var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2124 10.9922L19.2983 1.88581C20.3873 0.79433 22.1114 0.79433 23.2005 1.88581C24.2389 2.92657 24.2694 4.64577 23.2687 5.72575C23.2464 5.74985 23.2236 5.77353 23.2005 5.79675L14.4026 14.6145L10.2124 15.4673V10.9922Z",
    stroke: "#3E3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7809 0.0289172C17.6857 0.00994856 17.5872 -1.8754e-07 17.4863 -2.01056e-07L1.50005 -2.34381e-06C0.671625 -2.45485e-06 5.14888e-05 0.671571 5.1477e-05 1.5L5.12005e-05 20.9002C5.11887e-05 21.7286 0.671625 22.4002 1.50005 22.4002L17.4863 22.4002C18.3148 22.4002 18.9863 21.7286 18.9863 20.9002L18.9863 14.3029L17.9863 15.1788L17.9863 20.9002C17.9863 21.1763 17.7625 21.4002 17.4863 21.4002L1.50005 21.4002C1.22391 21.4002 1.00005 21.1763 1.00005 20.9002L1.00005 1.5C1.00005 1.22386 1.22391 0.999998 1.50005 0.999998L16.8108 1L17.7809 0.0289172Z",
    fill: "#3E3D3D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.865c9842c17ecbec454a52a18cc90343.svg";
export { ForwardRef as ReactComponent };